import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Chip from '../Common/Chip';
import SelectModule from './SelectModule';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';

class SelectModules extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            moduleIds: this.props.moduleIds || [],
            modules: []
        };
    }

    componentDidMount() {
        this.onSelect = this.onSelect.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onModuleChange = this.onModuleChange.bind(this);

        this.listener = ModuleStore.addListener(this.onModuleChange);

        if (!!this.props.moduleIds.length) {
            ModuleActions.getSimplifiedList(this.props.moduleIds);
        }
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        return (
            <div>
                <SelectModule
                    label="Include modules"
                    onSelect={(name, id) => this.onSelect(name, id)}
                    clearOnSelect
                />
                <div className="cent-form-chips">
                    {this.state.modules.map((module) => {
                        return (
                            <Chip
                                key={module.id}
                                label={module.name}
                                onDelete={() => this.onDelete(module.id)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    onSelect(name, id) {
        if (this.state.moduleIds.includes(id)) { return null; }
        this.setState({
            modules: [...this.state.modules, {id, name}],
            moduleIds: [...this.state.moduleIds, id]
        });
        this.props.onSelect(name, id);
    }

    onDelete(moduleId) {
        this.setState({
            modules: this.state.modules.filter((e) => e.id !== moduleId),
            moduleIds: this.state.moduleIds.filter((id) => id !== moduleId)
        });
        this.props.onDelete(moduleId);
    }

    onModuleChange() {
        const modules = !!this.state.moduleIds.length && ModuleStore.getByIds(this.state.moduleIds);
        if (!!modules) {
            this.setState({modules});
        }
    }
}

SelectModules.propTypes = {
    moduleIds: PropTypes.arrayOf(PropTypes.number),
    onSelect: PropTypes.func,
    onDelete: PropTypes.func
};

SelectModules.defaultProps = {
    moduleIds: [],
    onSelect: () => {},
    onDelete: () => {}
};

export default SelectModules;
